/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_massmol_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molarity Calculator (Mass, Molarity, Volume) — Toolverse`)
};

const es_massmol_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Molaridad (Masa, Molaridad, Volumen) — Toolverse`)
};

const de_massmol_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molaritätsrechner (Masse, Molarität, Volumen) — Toolverse`)
};

const nl_massmol_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molariteitscalculator (massa, molariteit, volume) — Toolverse`)
};

const fr_massmol_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de molarité (masse, molarité, volume) — Toolverse`)
};

const it_massmol_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di molarità (massa, molarità, volume) — Toolverse`)
};

const pt_br2_massmol_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Molaridade (Massa, Molaridade, Volume) — Toolverse`)
};

const pt_massmol_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Molaridade (Massa, Molaridade, Volume) — Toolverse`)
};

const ja_massmol_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モル濃度計算ツール (質量・モル濃度・体積) — Toolverse`)
};

const zh_massmol_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`摩尔浓度计算器（质量、摩尔浓度、体积）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const massmol_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.massmol_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("massmol_meta_title", locale)
	if (locale === "en") return en_massmol_meta_title(inputs)
	if (locale === "es") return es_massmol_meta_title(inputs)
	if (locale === "de") return de_massmol_meta_title(inputs)
	if (locale === "nl") return nl_massmol_meta_title(inputs)
	if (locale === "fr") return fr_massmol_meta_title(inputs)
	if (locale === "it") return it_massmol_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_massmol_meta_title(inputs)
	if (locale === "pt") return pt_massmol_meta_title(inputs)
	if (locale === "ja") return ja_massmol_meta_title(inputs)
	return zh_massmol_meta_title(inputs)
};